var _g, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconToriGate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_tori_gate_svg__clip0_49526_27316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14A7 7 0 107 0a7 7 0 000 14z",
    fill: "#CE2B18"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.652v.694l.12.12 1.53 1.4.12.095h.55V7.11h-.765v.765h.765v4.211h.766v-4.21h3.828v4.21h.766v-4.21h.765V7.11H9.68V5.96h.526l.12-.096 1.53-1.4.12-.119v-.694l-.466.108c-.013.003-1.628.287-4.51.287-2.882 0-4.52-.284-4.534-.287L2 3.652zm1.471.993c.809.081 1.965.168 3.529.168 1.552 0 2.702-.088 3.505-.168l-.598.55H4.069l-.598-.55zm1.615 1.316h1.148V7.11H5.086V5.96zm2.68 0h1.148V7.11H7.766V5.96z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_tori_gate_svg__clip0_49526_27316"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
}

export default SvgIconToriGate;